import React from 'react'
import { useLocation } from 'react-router-dom'

import analytics from './analytics'

export default function useGoogleAnalytics() {
  const location = useLocation()

  React.useEffect(() => {
    analytics.init()
  }, [])

  React.useEffect(() => {
    let utm = ''

    if ('/apply$/'.match(location.pathname)) {
      utm = `?utm_source=${Date.now()}&utm_medium=payApply&utm_name=payApply`
    } else if (location.pathname.includes('/transactions/search')) {
      utm = `?utm_source=${Date.now()}&utm_medium=transactions&utm_name=transactions`
    } else if ('/statistics$/'.match(location.pathname)) {
      utm = `?utm_source=${Date.now()}&utm_medium=statistics&utm_name=statistics`
    }

    const currentPath = location.pathname + location.search + utm
    analytics.sendPageview(currentPath)
  }, [location])
}
